import React, { useState } from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  ExternalLink,
} from '../../components';
import how1 from './how1.jpg';
import css from './HowItWorksPage.module.css';

const HowItWorksPage = () => {
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const [hostsSelected, setHostsSelected] = useState(true);

  // prettier-ignore
  return (
    <StaticPage
      title="Wie es funktioniert"
      description="So funktioniert Unterkunft-Kirchentag.de: In wenigen Schritten eine Privatunterkunft für den Evangelischen Kirchentag 2027 in Düsseldorf anbieten oder einen Schlafplatz finden."
      schema={{
        '@context': 'http://schema.org',
        '@type': 'HowItWorksPage',
        description: 'Wie es funktioniert',
        name: 'Wie es funktioniert',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>

          <h1 className={css.pageTitle}>Wie es funktioniert</h1>
          <img src={how1} className={css.coverImage} />

          <div className={css.switchButtonsWrapper}>
            <div
              onClick={() => setHostsSelected(true)}
              className={hostsSelected ? css.buttonFocused : css.buttonNotFocused} style={{ borderRight: "none", borderTopLeftRadius: 22, borderBottomLeftRadius: 22 }}>
              Für Gastgeber:innen
            </div>
            <div
              onClick={() => setHostsSelected(false)}
              className={!hostsSelected ? css.buttonFocused : css.buttonNotFocused} style={{ borderLeft: "none", borderTopRightRadius: 22, borderBottomRightRadius: 22 }}>
              Für Besucher:innen
            </div>
          </div>

          {
            hostsSelected ?
              <div>
                <p dir="auto" className={css.subtitle}>Wie es funktioniert – für Gastgeber:innen</p>
                <p dir="auto">
                  Du wohnst in Düsseldorf und Umgebung und hast Kapazitäten, Besucher:innen des Deutschen Evangelischen Kirchentags in Düsseldorf vom 5. bis 9. Mai 2027 kostenlos einen Schlafplatz anzubieten? Wir würden uns sehr darüber freuen!
                </p>
                <p dir="auto">
                  Egal ob Wohnung, Zimmer, Bett, Luftmatratze, Stellplatz für Wohnmobile, Zeltwiese oder einfach etwas Platz für eine Isomatte auf dem Fußboden – wir und Besucher:innen des Kirchentags freuen sich über jede Art der Teilnahme. Auf unserer Webseite kannst Du Besucher:innen auf zwei verschieden Wegen eine Unterkunft anbieten:    </p>

                <p dir="auto"><strong>(A) Erstelle einen Eintrag für ein Unterkunftsangebot</strong></p>

                <ol dir="auto">
                  <li><a href='/signup'>Registriere</a> dich auf der Webseite</li>
                  <li>Klicke auf die Schaltfläche <a href="/l/draft/00000000-0000-0000-0000-000000000000/new/features">
                    +Neuen Eintrag erstellen
                  </a> und folge den Schritten, um einen neuen Eintrag zu erstellen</li>

                  <li>Nach Deiner Registrierung und der Veröffentlichung Deines Eintrags ist Dein Unterkunftsangebot öffentlich auf der Webseite Unterkunft-Kirchentag einsehbar </li>
                  <li>Nutzer:innen, die Unterkünfte suchen, können Dich direkt über den integrierten Chat kontaktieren. Wir informieren dich per E-Mail über neue Nachrichten. </li>
                  <li> Sobald Du in Kontakt mit Besucher:innen bist, könnt ihr weitere Absprachen treffen</li>
                </ol>

                <p dir="auto"><strong>(B) Kontaktiere Unterkunftssuchende direkt</strong></p>

                <ol dir="auto">
                  <li>Besuche die Startseite der Webseite und klicke auf die Schaltfläche „Alle Einträge anzeigen“</li>
                  <li>Du kannst die Suchergebnisse filtern - z. B. basierend auf den unterschiedlichen Kategorien</li>
                  <li>Durchsuche die Einträge und schaue, ob ein Eintrag bzw. Gesuch deine Angebotskriterien erfüllt </li>
                  <li>Klicke auf die Schaltfläche „Kontaktieren“. Um direkt mit Autor:innen des Eintrags in Kontakt treten zu können, <a href='/login'>logge dich</a> in dein bereits erstelltes Konto ein oder <a href='/signup'>registriere</a> dich neu.</li>
                  <li>Sobald Du in Kontakt mit dem/der Unterkunftssuchenden bist, könnt ihr weitere Absprachen treffen</li>
                  <li>Weitere Informationen findest du in unseren <a href='/faq'>häufig gestellten Fragen.</a></li>
                </ol>
                <p dir="auto">Wir empfehlen allen Nutzer:innen, sich im Verlauf der Kontaktaufnahme mit anderen Nutzer:innen besser kennenzulernen. Beispiele dafür sind z. B. ein gemeinsames Kennenlernen durch ein Telefonat oder Videotelefonat und das anschließende Austauschen von Personalien. </p>
                <p dir="auto">Bitte wirf auch einen Blick auf unsere zusätzlichen Sicherheits-Informationen. <a href='/safety-center'>Klicke hier</a> für mehr Details.</p>
              </div>
              :
              <div>
                <p dir="auto" className={css.subtitle}>Wie es funktioniert – Für Unterkunftssuchende</p>
                <p dir="auto">Du suchst nach einem Schlafplatz bzw. einer Unterkunft oder auch einem Stell- oder Zeltplatz für deinen Besuch auf dem Deutschen Evangelischen Kirchentag in Düsseldorf vom 5. bis 9. Mai 2027? Auf unserer Webseite kannst Du auf zwei verschiedenen Wegen eine Unterkunft finden:</p>

                <p dir="auto"><strong>(A) Erstelle einen Eintrag für ein Unterkunftsgesuch</strong></p>

                <ol dir="auto">

                  <li><a href='/signup'>Registriere</a> dich auf der Webseite</li>
                  <li>Klicke auf die Schaltfläche <a href="/l/draft/00000000-0000-0000-0000-000000000000/new/features">
                    +Neuen Eintrag erstellen
                  </a> und folge den Schritten um einen neuen Eintrag zu erstellen</li>
                  <li>Nach Deiner Registrierung und der Veröffentlichung Deines Eintrags ist Dein Unterkunftsgesuch öffentlich auf der Webseite Unterkunft-Kirchentag einsehbar </li>
                  <li>Nutzer:innen, die Unterkünfte anbieten, können Dich direkt über den integrierten Chat kontaktieren. Wir informieren dich per E-Mail über neue Nachrichten. </li>
                  <li>Sobald Du in Kontakt mit Gastgeber:innen bist, könnt ihr weitere Absprachen tätigen</li>
                </ol>

                <p dir="auto"><strong>(B) Tritt in Kontakt mit Gastgeber:innen</strong></p>

                <ol dir="auto">
                  <li>Besuche die Startseite der Webseite und klicke auf die Schaltfläche „Alle Einträge anzeigen“</li>
                  <li>Du kannst die Suchergebnisse filtern - z. B. basierend auf den unterschiedlichen Kategorien</li>
                  <li>Durchsuche die Einträge und schaue, ob ein Eintrag bzw. Unterkunftsangebot deine Suchkriterien erfüllt</li>
                  <li>Klicke auf die Schaltfläche „Kontaktieren“. Um direkt mit Autor:innen des Eintrags in Kontakt treten zu können, <a href='/login'>logge dich</a> in dein bereits erstelltes Konto ein oder <a href='/signup'>registriere</a> dich neu.</li>
                  <li>Sobald Du in Kontakt mit Gastgeber:innen bist, könnt ihr weitere Absprachen tätigen</li>
                  <li>Weitere Informationen findest du in unseren <a href='/faq'>häufig gestellten Fragen.</a></li>
                </ol>
                <p dir="auto">Wir empfehlen allen Nutzer:innen, sich im Verlauf der Kontaktaufnahme mit anderen Nutzer:innen besser kennenzulernen. Beispiele dafür sind z. B. ein gemeinsames Kennenlernen durch ein Telefonat oder Videotelefonat und das anschließende Austauschen von Personalien.</p>
                <p dir="auto">Bitte wirf auch einen Blick auf unsere zusätzlichen Sicherheits-Informationen. <a href='/safety-center'>Klicke hier</a> für mehr Details.</p>
              </div>

          }


        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default HowItWorksPage;
